import { render, staticRenderFns } from "./Siupal.vue?vue&type=template&id=a7b47780&"
import script from "./Siupal.vue?vue&type=script&lang=js&"
export * from "./Siupal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports